"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetch;
var ERROR = {
  NO_URL: 401,
  IMG_ON: 400,
  IMG_CATCH: 402,
  BEACON_FALSE: 403,
  XHR_ON: 500,
  RESPONSE: 501,
  TIMEOUT: 505
};
function fetch(url, data, timeout, withCredentials, success, fail, method, encryption) {
  try {
    var xhr = new XMLHttpRequest();
    var _method = method || 'POST';
    xhr.open(_method, "".concat(url));
    xhr.setRequestHeader("Content-Type", "application/json");
    if (withCredentials) {
      xhr.withCredentials = true;
    }
    if (timeout) {
      xhr.timeout = timeout;
      xhr.ontimeout = function () {
        fail && fail(url, data, ERROR.TIMEOUT);
      };
    }
    xhr.onload = function () {
      if (success) {
        var res = null;
        if (xhr.responseText) {
          try {
            res = JSON.parse(xhr.responseText);
            if (res && Number(res.resultCode) === 200) {
              success(res, data);
            } else {
              fail && fail(url, data, ERROR.XHR_ON);
            }
          } catch (e) {
            fail && fail(url, data, ERROR.XHR_ON);
          }
        }
      }
    };
    xhr.onerror = function () {
      xhr.abort();
      fail && fail(url, data, ERROR.XHR_ON);
    };
    if (encryption) {
      xhr.send(data);
    } else {
      xhr.send(JSON.stringify(data));
    }
  } catch (e) {}
}